import { memo } from "react";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { useTranslation } from "next-i18next";
import { addDofollowToAnchors } from "../utils/modifyHtmlLinks";
import { getCloudfrontUrl } from "../utils/mediaHelper";
import Image from "next/image";
import Link from "next/link";
import { truncateHTML } from "../utils/truncateHTML";

const CaseStudiesSection = memo(({ item, index, className = "" }) => {
  const { t } = useTranslation("common");
  const router = useRouter();
  const lang = router.locale || "en";

  // Optional: if you have a subtitle/kicker field use that, else fallback
  const kicker =
    item?.subTitle ||
    item?.subtitle ||
    (lang === "ar"
      ? "تحسين نتائج الموقع"
      : "Increase website visits to " + (item?.title || ""));

  // Your current hardcoded results (replace with real API fields if available)
  const stat1 = index === 0 ? "+600% Online Leads" : "+350% Online Leads";
  const stat2 = index === 0 ? "+360% Organic Traffic" : "+500% Organic Traffic";

  return (
    <div className={`w-full ${className}`}>
      <div className="w-full grid grid-cols-1 lg:grid-cols-[420px_1fr] gap-6 lg:gap-10 items-center">
        {/* LEFT: Image (420x420) */}
        {/* <div
          className="w-full lg:w-[420px] h-[320px] lg:h-[420px] rounded-[16px] overflow-hidden bg-cover bg-center"
          style={{
            // backgroundImage: `url('${encodeURI(
            //   item?.coverImage || "/frame-432@3x.png"
            // )}')`,
            backgroundImage: `url('${
              getCloudfrontUrl(encodeURI(item?.coverImage)) ||
              "/frame-432@3x.png"
            }')`,
          }}
        /> */}

        {/* <div className="relative w-full lg:w-[420px] h-[320px] lg:h-[420px] rounded-[16px] overflow-hidden bg-gray-100">
          <Image
            src={getCloudfrontUrl(item?.coverImage) || "/frame-432@3x.png"}
            alt={item?.title || "Case study"}
            fill
            className="object-cover"
            sizes="(max-width: 1024px) 100vw, 420px"
            quality={70}
          />
        </div> */}
        <div className="relative w-full max-w-[420px] aspect-[690/360] rounded-[16px] overflow-hidden bg-gray-100 mx-auto lg:mx-0">
          {/* <Link
            className="no-underline d-block w-full h-full"
            href={`/case-study/${item?.slug}`}
          > */}
          <Image
            src={getCloudfrontUrl(item?.coverImage) || "/frame-432@3x.png"}
            alt={item?.coverImage_alt || `Case Study ${index + 1} Image`}
            fill
            className="object-cover object-top"
            sizes="(max-width: 1024px) 100vw, 420px"
            quality={70}
          />
          {/* </Link> */}
        </div>
        {/* RIGHT: Content */}
        <div className="flex flex-col w-full gap-4 lg:gap-6">
          {/* Kicker */}

          <h3 className="m-0 text-[20px] lg:text-[24px] leading-[140%] font-medium text-white">
            {item?.title}
          </h3>

          {/* Green bar (single row) */}
          <div className="w-full bg-mediumseagreen rounded-[4px] px-4 py-2">
            <p className="m-0 text-[14px] sm:text-[16px] lg:text-[18px] font-semibold text-white">
              {stat1} &nbsp;&nbsp; {stat2}
            </p>
          </div>

          {/* Description */}
          <div
            className="text-[14px] lg:text-[16px] leading-[150%] text-white/80 rich-text"
            dangerouslySetInnerHTML={{
              __html:
                addDofollowToAnchors(truncateHTML(item?.description, 220)) ||
                "",
            }}
          />

          {/* CTA */}
          <div className="pt-2">
            <Link
              className="no-underline rounded-[50px] bg-white text-black text-[14px] lg:text-[16px] font-medium py-2.5 px-6 cursor-pointer hover:bg-[#e72c46] hover:text-white transition duration-300 ease-in-out"
              href={`/case-study/${item?.slug}`}
              aria-label={`Read the ${item?.title} case study`}
            >
              {t("btnTxt.learnMore")}
            </Link>
          </div>
        </div>
      </div>

      {/* divider between rows (optional, matches stacked look) */}
      <div className="w-full h-px mt-10 bg-white/10" />
    </div>
  );
});

CaseStudiesSection.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  className: PropTypes.string,
};

export default CaseStudiesSection;
